import React from "react";
import { ActionType } from "~/pages/constants";
import { TradeToken } from "~/types";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Image } from "antd-mobile";
import ImgSwapBuy from "~/assets/imgs/swap_bg_buy.png";
import ImgSwapSell from "~/assets/imgs/swap_bg_sell.png";
import { hapticFeedback } from "@telegram-apps/sdk-react";

type TradeActionSegmentedButtonProps = {
    tradeToken: TradeToken;
    tradeActionType: ActionType;
    setTradeActiveType: (
        tradeToken: TradeToken,
        tradeActionType: ActionType
    ) => void;
};

const TradeActionSegmentedButton: React.FC<TradeActionSegmentedButtonProps> = ({
    tradeToken,
    tradeActionType,
    setTradeActiveType,
}) => {
    const { t } = useTranslation();
    return (
        <div className="flex items-center h-7 mb-[8px] border-[0.5px] border-border_2 rounded overflow-hidden">
            <div className="flex-1 relative rounded overflow-hidden">
                <button
                    className={clsx(
                        `h-7 w-full z-10 text-body3 text-text_2 rounded relative`,
                        tradeActionType === ActionType.Buy &&
                            "font-semibold text-white"
                    )}
                    onClick={() => {
                        hapticFeedback.impactOccurred("light");
                        setTradeActiveType(tradeToken, ActionType.Buy);
                    }}
                >
                    {t("buy")}
                </button>
                {tradeActionType === ActionType.Buy && (
                    <Image
                        src={ImgSwapBuy}
                        className={clsx(
                            "absolute top-0 left-0 right-0 bottom-0 select-none border-none outline-none"
                        )}
                    />
                )}
            </div>
            <div className="flex-1 relative rounded overflow-hidden">
                <button
                    className={clsx(
                        `h-7 w-full text-text_2 text-body3 rounded relative z-10`,
                        tradeActionType === ActionType.Sell &&
                            "font-semibold text-white"
                    )}
                    onClick={() => {
                        hapticFeedback.impactOccurred("light");
                        setTradeActiveType(tradeToken, ActionType.Sell);
                    }}
                >
                    {t("sell")}
                </button>
                {tradeActionType === ActionType.Sell && (
                    <Image
                        src={ImgSwapSell}
                        className={clsx(
                            "absolute top-0 left-0 right-0 bottom-0 select-none border-none outline-none"
                        )}
                    />
                )}
            </div>
        </div>
    );
};

export default TradeActionSegmentedButton;
